import { Create } from "../../../components/base-requirements/Create.tsx";

export default function CreateBaseRequirementPage() {
  return (
    <div className="w-full h-full p-8">
      <Create />
    </div>
  );
}
